import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'

const App: FC<MicroFrontendProps> = (microFrontendProps) => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsInjected, setCssIsInjected] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components only)
      setCssIsInjected(true)
    }
  }

  return (
    <div ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={
          process.env.REACT_APP_DEPLOY_PATH
            ? process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'
            : 'static/css/main.css'
        }
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  // dynamic import of DevTools because we don't want to load them in prod
  import('@ta-interaktiv/microfrontend-devtools').then((module) => {
    const { DevTools } = module
    const DevToolAppWrapper = () => {
      App.defaultProps = {
        properties: {
          module: 'scrollytelling',
        },
      }
      const [ref, setRef] = useState<HTMLDivElement | null>()
      return (
        <div ref={(newRef) => setRef(newRef)}>
          {ref && (
            <StyleSheetManager target={ref}>
              <DevTools MicroFrontend={App} />
            </StyleSheetManager>
          )}
        </div>
      )
    }
    const shadow = document
      .getElementById('root')
      ?.attachShadow({ mode: 'closed' })
    const root = createRoot(shadow!)
    // get all style tags from the head and append them to the shadow dom
    const styleTags = document.querySelectorAll('style')
    styleTags.forEach((styleTag) => {
      shadow?.appendChild(styleTag.cloneNode(true))
    })
    root.render(
      <React.StrictMode>
        <DevToolAppWrapper />
      </React.StrictMode>
    )
  })
}
